import publicApi from "./publicApi";

const dsaCareerService = {
  async create(payload) {
    const response = await publicApi.post("/dsa-enquiries", payload);

    return response.data.data;
  },
};

export default dsaCareerService;
